import React from 'react'
import Image from '../../Element/Image/Image'
import Tag from '../../Element/Tag/Tag'
import IProps from './interface'
import classNames from 'classnames'
import Title from '../../Element/Title/Title'
import Link from '../../Element/Link/Link'

const NewsCard = (props: IProps) => {
  const {
    categoryName,
    title,
    subtitle,
    description,
    image,
    tags,
    cta,
    layout = 'default',
  } = props

  return (
    <section
      aria-labelledby={title?.id}
      className={classNames({
        ['newsCard']: true,
        ['newsCard--landscape']: layout === 'landscape',
      })}>
      {image ? (
        <div className='newsCard__image-wrapper'>
          {cta ? (
            <a
              href={cta.href}
              aria-label={title?.text}
              tabIndex={-1}
              aria-hidden='true'>
              <Image {...image} />
            </a>
          ) : (
            <Image {...image} />
          )}
        </div>
      ) : null}
      <div className={classNames('newsCard__infoWrapper', { '!mt-0': !image })}>
        {categoryName ? (
          <span className='newsCard__categoryName'>{categoryName}</span>
        ) : null}
        {title ? (
          cta ? (
            <a href={cta.href}>
              <Title
                classes='newsCard__title'
                id={title.id}
                type={title.type}
                customAttributes={{}}>
                {title.text}
              </Title>
            </a>
          ) : (
            <Title classes='newsCard__title' id={title.id} type={title.type}>
              {title.text}
            </Title>
          )
        ) : null}
        {subtitle ? <p className='newsCard__subtitle'>{subtitle}</p> : null}
        {description ? (
          <p className='newsCard__description'>{description}</p>
        ) : null}
        {tags?.length ? (
          <div className='newsCard__tags'>
            {tags.map((tag, index) => (
              <Tag
                text={tag.text}
                href={tag.href}
                target={tag.target}
                classes={tag.classes}
                key={`tag-${index}`}
              />
            ))}
          </div>
        ) : null}
        {cta ? (
          <div className={classNames('newsCard__button')}>
            {cta && (
              <Link {...cta}>
                {cta.text} <i aria-hidden='true'>arrow_forward</i>
              </Link>
            )}
          </div>
        ) : null}
      </div>
    </section>
  )
}

export default NewsCard
